import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { usePageTitle } from "@/lib/usePageTitle";

const CLS = { scheduled: "matched", in_progress: "quote", completed: "done", requested: "requested", quoted: "quote" };

export default function StaffDashboard() {
  usePageTitle("Today's schedule — Olivia Does");
  const [jobs, setJobs] = useState([]);
  useEffect(() => { api.get("/jobs").then((r) => setJobs(r.data)); }, []);

  const wip = jobs.filter((j) => j.status === "in_progress");
  const today = jobs.filter((j) => j.status === "scheduled");
  const list = [...wip, ...today];

  return (
    <section className="od-section od-wrap" data-testid="staff-dashboard">
      <div className="od-eyebrow">In-house operations</div>
      <h1 className="serif" style={{ fontSize: "2.1rem", fontWeight: 500, margin: "6px 0 24px" }}>Today's schedule</h1>
      {list.length === 0 ? (
        <div className="card" style={{ textAlign: "center", color: "var(--taupe)", padding: 40 }}>Nothing scheduled. Enjoy the calm.</div>
      ) : (
        <div className="ogrid cols-2">
          {list.map((j) => (
            <Link to={`/jobs/${j.id}`} key={j.id} data-testid={`staff-job-${j.id}`} className="jobcard" style={{ display: "block", marginBottom: 0 }}>
              <div className="head">
                <div><div className="od-eyebrow">{j.scheduled_at || j.preferred_date || "TBD"} · {j.category}</div><h3 style={{ margin: 0, fontWeight: 500 }}>{j.title}</h3></div>
                <span className={`status-badge ${CLS[j.status] || "requested"}`}>{j.status.replace("_", " ")}</span>
              </div>
              <p style={{ color: "var(--taupe)", marginTop: 8, fontSize: ".85rem" }}>📍 {j.address}</p>
              <p style={{ color: "var(--taupe)", marginTop: 4, fontSize: ".82rem" }}>Customer: {j.customer_name}</p>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
